<style lang="scss" scoped>
.footer-page {
    min-height: 280px;
    width: 100%;
    background-color: #10162A;
    color: #ffffff;

    .contetn-box {
        width: 100%;

        margin: 0 auto;
        border-bottom: 1px dashed rgba(224, 234, 255, 0.14);
        padding: 0 18%;
        padding-bottom: 38px;

        .logo {
            height: 52px;
            margin-bottom: 30px;
        }
    }

    .right img {
        width: 112px;
        border-radius: 6px;
    }

    .right .desc {
        color: #ffffff;
        font-size: 12px;
        line-height: 12px;
        margin-top: 10px;
    }

    .email {
        .li {
            font-size: 12px;
            opacity: 0.7;

            img {
                max-height: 16px;
                margin-right: 10px;
            }

            &:first-child {
                margin-right: 42px;
            }

            transition: all .36s;

            &:hover {
                opacity: 1;
            }
        }
    }

    .ooperation {
        // padding-top: 38px;
        min-height: 70px;
        // padding-bottom: 38px;
        border-bottom: 1px dashed rgba(224, 234, 255, 0.14);
    }

    .copyright {
        font-size: 14px;
        color: #858d9e;
        line-height: 22px;
        text-align: center;
        opacity: 0.4;
    }
}
</style>

<template>
    <section class="footer-page">

        <div class="contetn-box df jcsb pt-15">
            <div>
                <img src="@/assets/images/logo-wit.png" class="logo" alt="">
                <div class="email df">
                    <div class="li"><img src="@/assets/images/icon-email.png" alt="">{{
                        $t('邮箱') }}：memberservice@oceanclub.org
                    </div>
                    <div class="li"><img src="@/assets/images/icon-wz.png" alt="">{{ $t('网址')
                        }}：http://www.oceanclub.org
                    </div>
                </div>
            </div>

            <div class="right f-r">
                <img src="@/assets/images/code.jpg" class="code" alt="">
                <p class="desc">{{ $t('扫描关注微信公众号') }}</p>
            </div>
        </div>

        <div class="ooperation">

        </div>
        <div class="copyright">
            {{ $t('版权所有') }}@oceanclub
        </div>
    </section>
</template>

<script>
export default {
    name: "Navbar",
    methods: {},
};
</script>
